module.exports = __webpack_public_path__ + "_/public/pin.png?95447b76";


//////////////////
// WEBPACK FOOTER
// ../public/pin.png
// module id = 616
// module chunks = 0